import { ScriveStandardProcessingAction } from '@/types';

export const ScriveConstants = {
  SuccessMessage: {
    [ScriveStandardProcessingAction.ReturnToPrepare]: 'The selected jobs were returned to prepare successfully',
    [ScriveStandardProcessingAction.Cancel]: 'The selected jobs are cancelled successfully',
    [ScriveStandardProcessingAction.SendForSigning]: 'Sent for signing successfully',
    [ScriveStandardProcessingAction.CancelSigning]: 'Signing was cancelled successfully'
  },
  CustomSignersTabKey: 'Custom-ScriveSignersTab'
};
